<template>
    <h4 class="d-inline mb-3">{{ $trans.get('__JSON__.' + title) }}</h4>          <i
            class="fa-solid fa-user-plus fa-2x text-primary d-inline float-end mb-3"
            @click="addModal"
            v-tooltip
            :title="$trans.get('__JSON__.Add employee')"
            role="button"
            id="addButton"
          ></i>

    <table class="table table-striped">
        <thead>
            <tr>
                <th>{{ $trans.get('__JSON__.' + 'Name') }}</th>
                <th>{{ $trans.get('__JSON__.' + 'Employeenumber') }}</th>
                <th>{{ $trans.get('__JSON__.' + 'Team') }}</th>
                <th>{{ $trans.get('__JSON__.' + 'Location') }}</th>
                <th>{{ $trans.get('__JSON__.' + 'Actions') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="employee in assignedEmployees">
                <td>{{ employee.lastname }}, {{ employee.forename }}</td>
                <td>{{ employee.employeenumber }}</td>
                <td>{{ employee.team?.name }}</td>
                <td>{{ employee.location?.name }}</td>
                <td>
                    <button class="btn btn-primary" @click.end.prevent="removeEmployee(employee.id)">{{
                        $trans.get('__JSON__.' + 'Remove') }}</button><input type="hidden" name="employee_ids[]"
                        :value="employee.id">
                </td>
            </tr>
        </tbody>
    </table>

    <Teleport to="body">
        <div class="modal" tabindex="-1" id="addModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $trans.get("__JSON__.Add employee") }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 col-12" id="employeeParent">
                            <label for="employee_id">{{ $trans.get("__JSON__.Employee") }}</label>
                            <input type="text" id="employeename" class="form-control" autocomplete="off" />
                            <input type="hidden" v-model="employeeId" id="employee_id" />
                        </div>
                    </div>
                    <div v-if="employeeAbsent" class="modal-footer d-flex justify-content-between">
                        <span class="text-danger">{{ $trans.get("__JSON__.Employee is absent on that date. Do you want to add them anyway?") }}</span>
                        <button type="button" class="btn btn-primary" @click="addEmployee(employeeId)">{{ $trans.get("__JSON__.Add") }}</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { ref, watch } from "vue";
import getEmployees from '../composables/getEmployees';
import axios from "axios";

export default {
    props: {
        title: String,
        employee_ids: Object,
        training: Object
    },
    data() {
        return {
            actualEmployeeIds: [],
            employeeAbsent: null,
            employeeId: null,
        };
    },

    setup(props) {
        const { employees, employees_error, loadEmployees } = getEmployees();
        loadEmployees(null, ['team', 'location']).then(response => {
            const acemployees = ref([]);

            employees.value.forEach((item) => {
                if (item.inactive == false) {
                    const employee = {
                        label: item.lastname + ", " + item.forename + " (" + item.employeenumber + ")",
                        value: item.id,
                    };
                    acemployees.value.push(employee);
                }
            });

            $('#employeename').autocomplete({
                source: acemployees.value,
                appendTo: '#employeeParent'
            });
        });

        return { employees, employees_error };
    },
    computed: {
        assignedEmployees() {
            if (this.employees) {
                return this.employees.filter((employee) => this.actualEmployeeIds.includes(employee.id));
            }
            return null;
        }
    },
    created() {
        this.actualEmployeeIds = [...this.employee_ids];
    },
    mounted() {
        var self = this;
        $('#employeename').on("autocompleteselect", function (event, ui) {
            $(this).val(ui.item.label);
            console.log(ui.item.value);
            self.employeeId = ui.item.value;
            self.checkOverlappingAbsence(ui.item.value);
            return false;
        });

    },
    methods: {
        removeEmployee(id) {
            this.actualEmployeeIds = this.actualEmployeeIds.filter((employeeId) => employeeId != id);
        },
        addEmployee(id) {
            this.actualEmployeeIds.push(id);
            $('#addModal').modal('hide');
        },
        checkOverlappingAbsence(id) {
            axios
                .get('/api/absences/' + id + '/checkabsent', {
                    params: {
                        date: this.training.start_at,
                    },
                })
                .then(response => {
                    this.employeeAbsent = response.data.isAbsent;
                    if (!response.data.isAbsent) {
                        this.addEmployee(id);
                    }
                })
                .catch(error => {
                    console.error('Error checking overlapping absence:', error);
                });
        },
        addModal() {
            $('#addModal').modal('show');
        }

    }

}
</script>

<style></style>